/**
 * @generated SignedSource<<ce80cffc7e7afba1efc56fc961864c75>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type dataHealthPage_Query$variables = Record<PropertyKey, never>;
export type dataHealthPage_Query$data = {
  readonly dataHealth: {
    readonly accounts: ReadonlyArray<{
      readonly coveredMonths: ReadonlyArray<string>;
      readonly driftMonths: ReadonlyArray<{
        readonly month: string;
        readonly value: number;
      }>;
      readonly firstMonth: string;
      readonly gapMonths: ReadonlyArray<string>;
      readonly kind: string;
      readonly lastMonth: string;
      readonly number: string;
      readonly staleSince: string | null | undefined;
    }>;
    readonly duplicateCharges: ReadonlyArray<{
      readonly accountNumbers: ReadonlyArray<string>;
      readonly amount: number;
      readonly count: number;
      readonly date: string;
      readonly description: string;
    }>;
    readonly gapMonths: ReadonlyArray<string>;
    readonly historyStartOn: any | null | undefined;
    readonly preflight: {
      readonly groups: ReadonlyArray<{
        readonly checks: ReadonlyArray<{
          readonly actionLabel: string | null | undefined;
          readonly actionPath: string | null | undefined;
          readonly actual: string | null | undefined;
          readonly detail: string | null | undefined;
          readonly key: string;
          readonly status: string;
          readonly target: string | null | undefined;
          readonly title: string;
        }>;
        readonly code: string;
        readonly greenCount: number;
        readonly title: string;
        readonly totalCount: number;
      }>;
      readonly score: {
        readonly amber: number;
        readonly green: number;
        readonly red: number;
        readonly total: number;
      } | null | undefined;
    };
    readonly sourceWindows: ReadonlyArray<{
      readonly dataFrom: any | null | undefined;
      readonly dataTo: any | null | undefined;
      readonly declaredFrom: any | null | undefined;
      readonly declaredTo: any | null | undefined;
      readonly effectiveFrom: any | null | undefined;
      readonly effectiveTo: any | null | undefined;
      readonly explained: boolean;
      readonly key: string;
      readonly kind: string;
      readonly label: string;
      readonly lateStart: boolean;
      readonly outOfWindowCount: number;
      readonly outOfWindowSample: ReadonlyArray<{
        readonly amount: number;
        readonly date: any;
        readonly description: string | null | undefined;
      }>;
      readonly reason: string | null | undefined;
    }>;
  };
};
export type dataHealthPage_Query = {
  response: dataHealthPage_Query$data;
  variables: dataHealthPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "historyStartOn",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "green",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amber",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "red",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "greenCount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "detail",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actual",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "target",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actionPath",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actionLabel",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataFrom",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataTo",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "declaredFrom",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "declaredTo",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveFrom",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveTo",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reason",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lateStart",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "explained",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "outOfWindowCount",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "OutOfWindowTxn",
  "kind": "LinkedField",
  "name": "outOfWindowSample",
  "plural": true,
  "selections": [
    (v28/*: any*/),
    (v29/*: any*/),
    (v30/*: any*/)
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gapMonths",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstMonth",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastMonth",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coveredMonths",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "staleSince",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "DuplicateChargeGroup",
  "kind": "LinkedField",
  "name": "duplicateCharges",
  "plural": true,
  "selections": [
    (v28/*: any*/),
    (v30/*: any*/),
    (v29/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountNumbers",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "dataHealthPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DataHealth",
        "kind": "LinkedField",
        "name": "dataHealth",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Preflight",
            "kind": "LinkedField",
            "name": "preflight",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PreflightScore",
                "kind": "LinkedField",
                "name": "score",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PreflightGroup",
                "kind": "LinkedField",
                "name": "groups",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PreflightCheck",
                    "kind": "LinkedField",
                    "name": "checks",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v6/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SourceWindow",
            "kind": "LinkedField",
            "name": "sourceWindows",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v31/*: any*/)
            ],
            "storageKey": null
          },
          (v32/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountCoverage",
            "kind": "LinkedField",
            "name": "accounts",
            "plural": true,
            "selections": [
              (v33/*: any*/),
              (v16/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v32/*: any*/),
              (v37/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "DriftMonth",
                "kind": "LinkedField",
                "name": "driftMonths",
                "plural": true,
                "selections": [
                  (v38/*: any*/),
                  (v39/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v40/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "dataHealthPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DataHealth",
        "kind": "LinkedField",
        "name": "dataHealth",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Preflight",
            "kind": "LinkedField",
            "name": "preflight",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PreflightScore",
                "kind": "LinkedField",
                "name": "score",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v41/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PreflightGroup",
                "kind": "LinkedField",
                "name": "groups",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PreflightCheck",
                    "kind": "LinkedField",
                    "name": "checks",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v6/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v41/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v41/*: any*/)
                ],
                "storageKey": null
              },
              (v41/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SourceWindow",
            "kind": "LinkedField",
            "name": "sourceWindows",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v31/*: any*/),
              (v41/*: any*/)
            ],
            "storageKey": null
          },
          (v32/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountCoverage",
            "kind": "LinkedField",
            "name": "accounts",
            "plural": true,
            "selections": [
              (v33/*: any*/),
              (v16/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v32/*: any*/),
              (v37/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "DriftMonth",
                "kind": "LinkedField",
                "name": "driftMonths",
                "plural": true,
                "selections": [
                  (v38/*: any*/),
                  (v39/*: any*/),
                  (v41/*: any*/)
                ],
                "storageKey": null
              },
              (v41/*: any*/)
            ],
            "storageKey": null
          },
          (v40/*: any*/),
          (v41/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "72a33308e00a2e748534edf7c1d047a4",
    "id": null,
    "metadata": {},
    "name": "dataHealthPage_Query",
    "operationKind": "query",
    "text": "query dataHealthPage_Query {\n  dataHealth {\n    historyStartOn\n    preflight {\n      score {\n        green\n        amber\n        red\n        total\n        id\n      }\n      groups {\n        code\n        title\n        greenCount\n        totalCount\n        checks {\n          key\n          title\n          status\n          detail\n          actual\n          target\n          actionPath\n          actionLabel\n          id\n        }\n        id\n      }\n      id\n    }\n    sourceWindows {\n      key\n      kind\n      label\n      dataFrom\n      dataTo\n      declaredFrom\n      declaredTo\n      effectiveFrom\n      effectiveTo\n      reason\n      lateStart\n      explained\n      outOfWindowCount\n      outOfWindowSample {\n        date\n        description\n        amount\n      }\n      id\n    }\n    gapMonths\n    accounts {\n      number\n      kind\n      firstMonth\n      lastMonth\n      coveredMonths\n      gapMonths\n      staleSince\n      driftMonths {\n        month\n        value\n        id\n      }\n      id\n    }\n    duplicateCharges {\n      date\n      amount\n      description\n      accountNumbers\n      count\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "698a5bb6f38fb59fea484aba225edfe0";

export default node;
